var _this = this;
import * as tslib_1 from "tslib";
import { baggageInfoActionTypes } from './ActionTypes';
import { BaggageInfoResponse } from '../../../globalTypes';
export var getBaggageInfo = function (baggageInfoRequest) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var baggageInfoResponse, res, response, _i, _a, current, currentId, currentId, _b, _c, current, currentId, currentId, error_1, receiveBaggageInfoAction;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    baggageInfoResponse = new BaggageInfoResponse();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(baggageInfoRequest.url, {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: baggageInfoRequest.data,
                        })];
                case 2:
                    res = _d.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _d.sent();
                    if (response.hasOwnProperty('freitexte')) {
                        if (response.freitexte.hasOwnProperty('ALL')) {
                            for (_i = 0, _a = response.freitexte.ALL; _i < _a.length; _i++) {
                                current = _a[_i];
                                baggageInfoResponse.addAllAirlineBaggageInfoText(current);
                            }
                        }
                        else {
                            if (response.freitexte.hasOwnProperty('Outbound')) {
                                for (currentId in response.freitexte.Outbound) {
                                    if (response.freitexte.Outbound.hasOwnProperty(currentId)) {
                                        baggageInfoResponse.setOutboundBaggageAirlineInfo(currentId, response.freitexte.Outbound[currentId]);
                                    }
                                }
                            }
                            if (response.freitexte.hasOwnProperty('Inbound')) {
                                for (currentId in response.freitexte.Inbound) {
                                    if (response.freitexte.Inbound.hasOwnProperty(currentId)) {
                                        baggageInfoResponse.setInboundBaggageAirlineInfo(currentId, response.freitexte.Inbound[currentId]);
                                    }
                                }
                            }
                        }
                    }
                    if (response.hasOwnProperty('freigepaeck')) {
                        if (response.freigepaeck.hasOwnProperty('ALL')) {
                            for (_b = 0, _c = response.freigepaeck.ALL; _b < _c.length; _b++) {
                                current = _c[_b];
                                baggageInfoResponse.addAllGepaeckInfoText(current);
                            }
                        }
                        else {
                            if (response.freigepaeck.hasOwnProperty('Outbound')) {
                                for (currentId in response.freigepaeck.Outbound) {
                                    if (response.freigepaeck.Outbound.hasOwnProperty(currentId)) {
                                        baggageInfoResponse.setOutboundGepaeckInfoText(currentId, response.freigepaeck.Outbound[currentId]);
                                    }
                                }
                            }
                            if (response.freigepaeck.hasOwnProperty('Inbound')) {
                                for (currentId in response.freigepaeck.Inbound) {
                                    if (response.freigepaeck.Inbound.hasOwnProperty(currentId)) {
                                        baggageInfoResponse.setInboundGepaeckInfoText(currentId, response.freigepaeck.Inbound[currentId]);
                                    }
                                }
                            }
                        }
                    }
                    baggageInfoResponse.setIsOk(true);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _d.sent();
                    return [3 /*break*/, 5];
                case 5:
                    receiveBaggageInfoAction = {
                        'type': baggageInfoActionTypes.RECEIVE_BAGGAGE_INFO_STATE,
                        'baggageInfoResponse': baggageInfoResponse
                    };
                    return [2 /*return*/, dispatch(receiveBaggageInfoAction)];
            }
        });
    }); };
};
